import {Component, Input, forwardRef, HostListener, ElementRef} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {SistemaService} from '@servicios/Sistema.Service';
import {TranslateService} from '@ngx-translate/core';;

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const CUSTOM_TIMEPICKER_CONTROL_VALUE_ACCESSOR: any =
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimePickerComponent),
    multi: true
  };


@Component(
  {
    selector: 'timePickerCustom',
    templateUrl: './TimePicker.template.html',
    styleUrls: ['./TimePicker.scss'],
    providers: [CUSTOM_TIMEPICKER_CONTROL_VALUE_ACCESSOR]
  })

export class TimePickerComponent implements ControlValueAccessor
{
  public innerValue : any = "";

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  public touched : any = "";

  @Input() titulo : string = ""; // titulo del input
  @Input() margenControl : boolean = true; // indica si el control lleva un margen de 30px (se recomienda para que el control sea responsivo automáticamente)
  @Input() meridiano : boolean = false; // indica si se muestra el botón para cambiar entre am pm

  @Input() limpiarInput : boolean = true; // muestra o no el botón para limpiar la seleccion
  @Input() disabled : boolean = false; // control deshabilitado
  @Input() verError : boolean = true; // indica si el error esta habilitado para mostrarse
  @Input() errorActivo : boolean = false; // indica si el error esta habilitado para mostrarse
  @Input() mensajeError : string = ""; // mensaje que desplegará cuando haya un error

  public id : number = 0;
  public hora : any;
  public horaMostrar : any;

  @HostListener('document:click', ['$event'])
  ClickTimePicker(event : any)
  {
    if(this.eRef.nativeElement.contains(event.target))
    {
      this.EvitarCierre();
    }
  }

  constructor(public sistemaService : SistemaService, public translate : TranslateService, private eRef : ElementRef)
  {
    this.mensajeError = this.translate.instant("DatoIncompeto");
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnInit()
  {
  }

  ngAfterViewInit()
  {
  }

  Focus()
  {
  }

  LimpiarValor()
  {
    this.hora = null;
    this.NuevaHora();
  }

  EvitarCierre()
  {
    $('#ddTimePicker' + this.id).click(function(e : any)
    {
      e.stopPropagation();
    });
  }

  NuevaHora()
  {
    this.valor = this.sistemaService.TimePickerToString(this.hora);
  }

  SetValor()
  {
    this.hora = this.sistemaService.String2TimePicker(this.valor);
  }

  // control ngModel
  get valor(): any
  {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set valor(nuevoValor: any)
  {
    if (nuevoValor !== this.innerValue)
    {
      this.innerValue = nuevoValor;
      this.SetValor();
      this.onChangeCallback(nuevoValor);
    }
  }

  writeValue(valor: any)
  {
    if (valor !== this.innerValue)
    {
      this.innerValue = valor;
      this.SetValor();
    }
  }

  registerOnChange(fn: any)
  {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any)
  {
    this.onTouchedCallback = fn;
  }
  
  TeclaPresionada(tecla : any)
  {
    if(tecla.keyCode ==  13 || tecla.keyCode == 32)
    {
      $('#ddBoton' + this.id).click();
    }
  }
}
